import type { WordStatus } from './word'

export type CardType = 'word' | 'phrase'

export interface CustomFlashcard {
  id: number
  lemma: string
  translation: string
  part_of_speech: string | null
  gender: string | null
  example_sentence: string | null
  notes: string | null
  status: WordStatus
  tracked_forms: string[]
  card_type: CardType
  deck_id: number | null
}

export interface CustomFlashcardInput {
  language_id: number
  lemma: string
  translation: string
  part_of_speech?: string | null
  gender?: string | null
  example_sentence?: string | null
  notes?: string | null
  tracked_forms?: string[]
  card_type?: CardType
  deck_id?: number | null
}

/** Mirrors the POS buckets in VocabularyBrainStatsQuery::POS_MAP. */
export const POS_OPTIONS = [
  'noun', 'verb', 'adjective', 'adverb',
  'pronoun', 'preposition', 'conjunction', 'determiner',
] as const

export const GENDER_OPTIONS = ['masculine', 'feminine', 'neuter', 'common'] as const
